/*
Ashraf 09/26/2022 2698777930 changed label for copy address and contacts
Akhila 09/30/2022 2698777930 added filed function in add client and dashboard
Sai krishna 10/03/2022 2698777930 Fixed merge conflicts.
*/
import React, {useEffect, useState} from 'react';
import {makeStyles, Button} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {postClientGeneral} from '../../../redux/reducers/client-maintainance/ClientGeneral';
import PageLoader from '../../../components/PageLoader';
import moment from 'moment';
import CopyAddressTable from './CopyAddressTable';
const useStyles = makeStyles((theme) => ({
  buttonRoot: {
    'lineHeight': 1.75,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
      padding: '6px 15px',
    },
    '& .MuiButton-label': {
      fontSize: '0.813rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.688rem',
        letterSpacing: 1,
      },
    },
  },
}));

function ClientConfirmationForm({setIsOpen, setSuccess, client, submitData, change, setChange}) {
  const classes = useStyles();
  const [copyAddressTableData, setCopyAddressTableData] = useState([]);
  const {subServiceTypes} = useSelector(({clientGeneral}) => clientGeneral);

  useEffect(() => {
    const arr = submitData.serviceType.map((service) => {
      return {
        clientCode: submitData.clientNumber + service?.clientCodeSuffix,
        parentAddress: false,
        parentContact: false,
      };
    });
    setCopyAddressTableData(arr);
  }, []);
  const getServiceType = (options, clientNumber) => {
    const filterOptions = options.flat();
    let values = '';
    if (filterOptions && filterOptions?.length > 0) {
      filterOptions?.forEach((item, index) => {
        values +=
          ' ' +
          clientNumber +
          item +
          (filterOptions?.length > 1 && index !== filterOptions?.length - 1 ? ',' : '');
      });
    }
    return values;
  };

  const {isLoading} = useSelector(({reports}) => reports);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    const serviceTypesObj = {};
    const subServiceTypeArray = [];
    const serviseTypesArray = submitData.serviceType.map((type) => {
      serviceTypesObj[type.serviceTypeId] = type;
      const obj = {...type};
      delete obj.serviceType;
      return obj;
    });
    subServiceTypes.forEach((type, i) => {
      const {subServiceTypeId} = type;
      if (submitData[`selected${subServiceTypeId}`] || submitData.companyType !== 'The WellFund, LLC') {
        const obj = {
          clientCodeSuffix: serviceTypesObj[type.serviceTypeId].clientCodeSuffix,
          feeType: submitData[`rateType${subServiceTypeId}`],
          feeValue: submitData[`value${subServiceTypeId}`],
          selectedSubType: 'Y',
          rateNotes: submitData[`rateNote${subServiceTypeId}`],
          paymentsRemitted: submitData[`debtorOverPayments${subServiceTypeId}`],
          inflationAgreement: submitData[`inflationAgreement${subServiceTypeId}`],
          postageAgreement: submitData[`postageAgreement${subServiceTypeId}`],
          serviceEndDt: submitData[`endDate${subServiceTypeId}`] ?
            moment(submitData[`endDate${subServiceTypeId}`]).format('YYYY-MM-DD') :
            '',
          serviceStartDt: moment(submitData[`effectiveDate${subServiceTypeId}`]).format('YYYY-MM-DD'),
          subServiceTypeId: type.subServiceTypeId,
        };
        subServiceTypeArray.push(obj);
      } else {
        const obj = {
          clientCodeSuffix: serviceTypesObj[type.serviceTypeId].clientCodeSuffix,
          feeType: '',
          feeValue: '',
          serviceEndDt: '',
          rateNotes: null,
          serviceStartDt: '',
          selectedSubType: 'N',
          subServiceTypeId: type.subServiceTypeId,
        };
        subServiceTypeArray.push(obj);
      }
    });
    const payload = {
      clientName: submitData.clientName,
      clientNumber: submitData.clientNumber,
      companyTypeRequest: {
        comapanyType: submitData.companyType,
        serviceType: serviseTypesArray,
        subServiceType: subServiceTypeArray,
      },
      copyClientAddressRequest: copyAddressTableData,
      isActive: 'Y',
      parentClientId: submitData.parentClientId.parentClientId,
    };

    dispatch(postClientGeneral(payload));
    setIsOpen(false);
  };
  return (
    <>
      {change ? (
        <div className="col-md-12">
          <CopyAddressTable
            copyAddressTableData={copyAddressTableData}
            setCopyAddressTableData={setCopyAddressTableData}
          />
        </div>
      ) : (
        <div className="col confirmation-dialogue">
          <p>
            Client Code
            {submitData?.serviceType?.length > 0 ?
              getServiceType(
                submitData?.serviceType?.map((item) => item?.clientCodeSuffix),
                submitData?.clientNumber,
              ) :
              submitData?.clientNumber}
            will be created.
          </p>
        </div>
      )}

      <div>
        <div className="d-flex justify-content-center mt-2">
          <Button
            type="button"
            variant="contained"
            className={` mx-1 ${classes.buttonRoot}`}
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          {!change ? (
            <Button
              type="button"
              variant="contained"
              className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
              onClick={() => setChange(true)}
            >
              ok
            </Button>
          ) : (
            <Button
              type="submit"
              variant="contained"
              className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
              onClick={() => handleSubmit()}
            >
              Save
            </Button>
          )}
        </div>
      </div>
      {isLoading && <PageLoader />}
    </>
  );
}

export default ClientConfirmationForm;
